import React from 'react';
import Card from '../../../../shared/components/Card';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardHeader from '../../../../shared/components/card-header/CardHeader';
import InputDate from '../../../../shared/components/InputDate';
import { PsTable } from '../../../../shared/components/table/PsTable';
import { PsDate } from '../../../../shared/model/PsDate';
import CardBody from '../../../../shared/components/CardBody';
import Row from '../../../../shared/components/Row';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ListPresencesRequest } from '../webservices/list-presence/ListPresencesRequest';
import { ListPresencesTask } from '../webservices/list-presence/ListPresencesTask';
import { PsPresence } from '../PsPresence';
import classNames from 'classnames';
import { ButtonIcon } from '../../../../shared/components/ButtonIcon';
import Alert from 'react-s-alert';
import './PresenceCard.css';
import DateUtils from '../../../../shared/utils/DateUtils';

export class PresenceImportDayCard extends React.Component {

    constructor(props) {
        super(props);

        const dateNow = DateUtils.buildDateFromString(PsDate.fromNow().toDateString());
        const previousDate = PsDate.fromDate(dateNow.setDate(dateNow.getDate() - 1));
        this.state = {
            presencesToImport: [],
            presencesToImportDate: previousDate,
            presencesToImportLoading: false,
        };
    }

    componentDidMount() {
        this.listPresencesToImport();
    }

    render() {
        const { presences, importDay } = this.props;
        const {
            presencesToImport,
            presencesToImportLoading,
            presencesToImportDate,
        } = this.state;

        return (
            <Card loading={presencesToImportLoading} className="worker-card">
                <CardHeader
                    title={I18nUtils.tr('TR_ANADIR_DESDE_OTRA_FECHA')}
                    rightOptions={
                        <HeaderSearchRefreshFilterOptions
                            enableSearch={false}
                            enableFilter={false}
                            enableRefresh={false}
                            moreOptions={this.moreOptions()}
                        />
                    }
                />
                <CardBody>
                    <Row>
                        <Col md={12} lg={12}>
                            <div className="form-group">
                                <InputDate
                                    col="col-lg-3 col-md-3 col-sm-3 col-xs-3"
                                    label={I18nUtils.tr('TR_FECHA')}
                                    value={presencesToImportDate.toDateString()}
                                    onChange={this.selectDate}
                                    className="form-input-date-container"
                                />
                                <PsTable>
                                    {
                                        presencesToImport && presencesToImport.length !== 0 ?
                                            presencesToImport.map(pti => {
                                                const isSelected = presences.find(p => p.equalsWorker(pti));
                                                const classes = classNames({ 'tr-disabled': isSelected });

                                                return (
                                                    <tr key={pti.id()} className={classes}>
                                                        <td>{pti.workerCompleteName()}</td>
                                                        <td>
                                                            <ButtonIcon
                                                                icon="add"
                                                                onClick={() => importDay([pti])}
                                                                disabled={isSelected}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            }) : (
                                                <h4 className="text-center">
                                                    {I18nUtils.tr('TR_NO_EXISTEN_PRESENCIAS_PARA_LA_FECHA_INDICADA')}
                                                </h4>
                                            )
                                    }
                                </PsTable>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        );
    }

    moreOptions() {
        const { presences } = this.props;
        const { presencesToImport } = this.state;
        const allWorkersFromImportedPresenceHavePresence =
            presencesToImport.every(ip => presences.some(p => p.equalsWorker(ip)));

        return [
            {
                id: 'add-all',
                title: I18nUtils.tr('TR_ANADIR_TODOS'),
                active: false,
                disabled: presencesToImport.length === 0 || allWorkersFromImportedPresenceHavePresence,
                onClick: this.importAllPresences,
            },
        ];
    }

    listPresencesToImport = () => {
        const { presencesToImportDate } = this.state;
        const { workId } = this.props;
        const request = new ListPresencesRequest();

        request.setConstructionId(workId);
        request.setDate(presencesToImportDate);

        new ListPresencesTask(request)
            .onPreExecution(() => this.setState({ presencesToImportLoading: true }))
            .onSuccess(res => {
                this.setState({
                    presencesToImport: PsPresence
                        .arrayFromBackend(res.data.presences || [])
                        .filter(presence => presence.isWorkerActive()),
                });
            })
            .onFail(error => Alert.error(error))
            .onPostExecution(() => this.setState({ presencesToImportLoading: false }))
            .execute();
    };

    selectDate = (date) => {
        const presencesToImportDate = PsDate.fromDDMMYYYY(date);
        this.setState({ presencesToImportDate }, this.listPresencesToImport);
    };

    importAllPresences = () => {
        const { presencesToImport } = this.state;
        const { presences, selectPresences } = this.props;
        const importedPresences = [];

        presencesToImport.forEach(pti => {
            const isSelected = presences.some(p => p.equalsWorker(pti));
            if ( !isSelected ) importedPresences.push(pti);
        });

        selectPresences([...presences, ...importedPresences]);
    };
}

PresenceImportDayCard.propTypes = {
    workId: PropTypes.number.isRequired,
    presences: PropTypes.array.isRequired,
    importDay: PropTypes.func.isRequired,
    selectPresences: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/add/PresenceImportDayCard.jsx